import type { components } from "@/types/api.generated";
import apiClient from "./client";

/**
 * O drill-down do plano de contas no Diagnóstico (#1374, EF-FUNC-009 §8.1).
 *
 * Aliases sobre os tipos gerados do OpenAPI, como em `diagnostic.ts`: o contrato
 * mora no backend. A lista é a mesma do nó, com a decisão efetiva de cada conta (a
 * do consultor, e a sugestão onde ele ainda não decidiu).
 */
export type CoaDiagnosticItems = components["schemas"]["CoaValidationItems"];
export type CoaDiagnosticItem = components["schemas"]["CoaValidationItem"];
export type CoaStatus = CoaDiagnosticItem["status"];
export type CoaAction = CoaDiagnosticItem["effective_decision"];

/** Filtros e página da lista, como a URL do detalhe os carrega. */
export interface CoaDiagnosticQuery {
  status?: CoaStatus;
  decision?: CoaAction;
  q?: string;
  page?: number;
  pageSize?: number;
}

/**
 * `GET /api/projects/{projectId}/diagnostic/chart-of-accounts`, paginado no servidor.
 *
 * Projeto sem análise responde 200 com a lista vazia.
 */
export async function getDiagnosticChartOfAccounts(
  projectId: string,
  query: CoaDiagnosticQuery,
): Promise<CoaDiagnosticItems> {
  const res = await apiClient.get<CoaDiagnosticItems>(
    `/api/projects/${projectId}/diagnostic/chart-of-accounts`,
    {
      params: {
        status: query.status,
        decision: query.decision,
        q: query.q || undefined,
        page: query.page ?? 1,
        page_size: query.pageSize ?? 50,
      },
    },
  );
  return res.data;
}
